export { bedrock, createAmazonBedrock } from './bedrock-provider';
export type {
  AmazonBedrockProvider,
  AmazonBedrockProviderSettings,
} from './bedrock-provider';
export type { BedrockProviderOptions } from './bedrock-chat-options';
export { VERSION } from './version';
